import { INIT_PAGINATION } from '@spx-portal/shared-utils';
import { useRequest } from 'ahooks';
import { useState } from 'react';
import { ProTableProps } from 'react-pro-components/typings/components/pro-table/types';

import { searchLogAdapter } from '../adapter';
import * as API from '../api';
import { useFields } from '../fields/single-fields';

export const useSingleTableProps = () => {
  const [pagination, setPagination] = useState(INIT_PAGINATION);
  const {
    loading,
    data,
    run: runLogList,
  } = useRequest(API.getSingleLogList, {
    manual: true,
    onSuccess(data, params) {
      const { total = 0 } = data;
      const newPagenation = params[0] || {};
      setPagination(prev => ({
        ...prev,
        total,
        current: newPagenation.pageno || 1,
        pageSize: newPagenation.count || 20,
      }));
    },
    onError(e) {
      console.error('Failed to fetch data:', e);
    },
  });

  const proTableProps: ProTableProps = {
    loading: loading,
    table: {
      dataSource: data?.list || [],
      columns: useFields().tableColumns,
      rowKey: 'log_id',
      pagination,
      sticky: true,
    },
    searchForm: {
      footerProps: { showReset: false },
    },
    fetchData:{
      fetcher: async(info: any) => {
        const { current, pageSize } = info.pagination || INIT_PAGINATION;
        await runLogList({
          pageno: current,
          count: pageSize,
          ...searchLogAdapter(info.form),
        });
      },
      fetchOnMount: true,
      fetchOnFormChange: false,
      fetchOnFormReset: true,
      fetchOnFormSubmit: true,
      fetchOnTableChange: true,
    },
  };

  return proTableProps;
};
